<template>
    <!--<div class="notes-container">-->
        <div class="row justify-content-center" >
            <div class="col-12" v-if="items.length>0">
                <div class="card table-responsive" style="margin-top:1%; background:none ">
                    <table class="table" style="background:white">
                        <thead>
                            <tr>
                                <th>Agregado</th>
                                <th>Fecha</th>
                                <th>Fuentes de Información</th>
                                <th>Keywords</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,ndx) in items" :key="item.key" >
                                                
                                <td>{{getNombre(item)}}</td>
                                <td>{{getFechas(item)}}</td>
                                <td><icons color="#062633" :arrFi="getFi(item)" /></td>
                                <td>{{getKeywords(item)}}</td>          
                                <td>
                                    <button style="width:30px;padding:0" class="button buttonTool tooltip " data-tooltip="Ver" @click="goTo(item)">
                                        <font-awesome-icon class="ficon" icon="eye" />
                                    </button>
                                    <button v-if="from!='public'" style="width:30px;padding:0" class="button buttonTool tooltip " data-tooltip="Eliminar" @click="borrar(item,ndx)">
                                        <font-awesome-icon class="ficon" icon="trash" />
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!--<div 
            class="pure-u-xl-3-24 pure-u-lg-4-24 pure-u-md-6-24 pure-u-sm-8-24 pure-u-12-24 mixedNotes" 
            v-for="item in items" :key="item.key"
        >
            <div class="folder touchpad noMargin" @click="goTo(item)">
                <div class="folder-image">
                    <div class="middle">
                        <div class="text"><font-awesome-icon icon="filter"/></div>
                    </div>  
                </div>
                <div class="folder-info">
                    <h3 class="title-folder"></h3>
                    <p class="folder-name" >Agregado el<br>{{getNombre(item)}} </p>
                </div>
            </div>                    
        </div>-->
    <!--</div>-->
</template>


<script>


import moment from 'moment-timezone'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight, faChevronLeft, faFilter, faTrash ,faEye} from '@fortawesome/free-solid-svg-icons'

library.add(faChevronRight)
library.add(faChevronLeft)
library.add(faFilter)
library.add(faTrash)
library.add(faEye)
import { Carousel, Slide } from 'vue-carousel';

import icons from "@/components/icons";






export default {
    name: 'sliderList',
    props:['items','cardClass','from'],
    components:{Carousel,Slide,icons},
    data() {
        return {
        }
    },
    mounted(){
        console.log('mounted sliderList');
        console.log(this.items);
        moment.tz.setDefault('America/Mexico_City');
    },
    methods:{
        getNombre(item){
            var  tmp =  moment(item.created);
            var f = moment.tz(tmp,'America/Mexico_City').format('DD/MM/YYYY');
            return f;
        },
        goTo(item){
           this.$emit('goTo',item)
        },
        getKeywords(item){
            var query = item.query? item.query : {};
            var keywords = query.keywords? query.keywords: [];
            return keywords.toString();
        },
        getFi(item){
            var query = item.query? item.query : {};
            var objectFi = query.fi? query.fi : {};
            var fi = Object.keys(objectFi);
            return fi;
        },
        getFechas(item){
            var query = item.query? item.query : {};
            console.log(query);
            var letrero = '';
            if(query.dias!='rango'){
                letrero = 'últimos ' + query.dias + ' dias';
            }else{
                if(query.fecha){
                    var inicio = query.fecha.ini;
                    var arr = inicio.split('-');
                    var fini = arr[2] + '/' + arr[1] + '/' + arr[0];
                    var arr2 = inicio.split('-');
                    var ffin = arr2[2] + '/' + arr2[1] + '/' + arr2[0];
                    letrero = fini + ' - ' + ffin;
                }
            }
            return letrero;
            
        },
        borrar(item,index){
            console.log('borrar')
            this.$emit('borrarSearch',{item:item,index:index})
        }
    }
}
</script>
<style scoped>

.cardEspecial{
    background-color: #EBF9FF; 
}

.folder-name{
color:#00B99E!important;
}
.touchpad{
    cursor: pointer;
}

.img-avatar{
    height: 100%;
}

.folder .folder-image{
  border: solid 6px #EBF9FF; /*00B99E*/
   color: #00B99E;
}


.folder .folder-image:hover  {
      background: #EBF9FF;
    
}


.folder-image .img-avatar {
  position: relative;
}


.folder-image .middle {
    height: auto;
    display: block;
    position: relative;
    transition: .5s ease;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    text-align: center;
 
}



.text{
    width:100%;
    font-size: 16px;
}



</style>